import { render, staticRenderFns } from "./SSOLogin.vue?vue&type=template&id=b4410778&scoped=true&"
import script from "./SSOLogin.vue?vue&type=script&lang=js&"
export * from "./SSOLogin.vue?vue&type=script&lang=js&"
import style0 from "./SSOLogin.vue?vue&type=style&index=0&id=b4410778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4410778",
  null
  
)

/* custom blocks */
import block0 from "./SSOLogin.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports